import { lightTheme } from "@/customTheme";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x={2.04641}
      y={2.04641}
      width={8.38337}
      height={8.38337}
      rx={2.09645}
      stroke={props.fill ? props.fill : lightTheme.colors.blackGray}
      strokeWidth={2.09282}
    />
    <rect
      x={2.04641}
      y={13.5703}
      width={8.38337}
      height={8.38337}
      rx={2.09645}
      stroke={props.fill ? props.fill : lightTheme.colors.blackGray}
      strokeWidth={2.09282}
    />
    <rect
      x={13.5698}
      y={2.04641}
      width={8.38337}
      height={8.38337}
      rx={2.09645}
      stroke={props.fill ? props.fill : lightTheme.colors.blackGray}
      strokeWidth={2.09282}
    />
    <rect
      x={13.5698}
      y={13.5703}
      width={8.38337}
      height={8.38337}
      rx={2.09645}
      stroke={props.fill ? props.fill : lightTheme.colors.blackGray}
      strokeWidth={2.09282}
    />
  </svg>
);
export default SVGComponent;
